import React, { Component } from 'react';
import { connect } from 'react-redux'
import { setLang } from '../actions/acCommon'

class LangSelector extends Component {
	state = {
		langSelectorActive: false,
		languages: {
			fr: { label: "Français" },
			nl: { label: "Nederlands" },
			en: { label: "English" }
		}
	}
	componentWillUnmount = () => {
		document.removeEventListener('click', this.handleClickOutside)
	}
	handleClickOutside = e => {
		e.stopPropagation()
		let wrapper = this.refs.wrapper
		let isClickInside = wrapper.contains(e.target);
		if (!isClickInside) {
			this.setState({ langSelectorActive: false })
			document.removeEventListener('click', this.handleClickOutside)
		}
	}
	toggleLangMenu = () => {
		this.setState(state => ({ langSelectorActive: !state.langSelectorActive }))
		document.addEventListener('click', this.handleClickOutside)
	}
	handleLangClick = e => {
		e.stopPropagation()
		let { lang } = e.target.dataset
		this.props.dispatch(setLang(lang))
		localStorage.setItem("pootsy-chosen-lang", lang)
		this.setState({ langSelectorActive: false })
	}
	render() {
		let { languages, langSelectorActive } = this.state
		let { lang } = this.props
		return (
			<div ref="wrapper" className={"LangSelector " + (langSelectorActive ? "active" : "")} onClick={this.toggleLangMenu}>
				<div className="selected">{languages[lang].label}</div>
				<div className="menu">
					{Object.keys(languages).map(entry =>
						<div
							key={entry} className={"menu-item" + (entry === lang ? " active" : "")}
							data-lang={entry} onClick={this.handleLangClick}
						>
							{languages[entry].label}
						</div>
					)}
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => ({ lang: state.i18nState.lang })
export default connect(mapStateToProps)(LangSelector);



// WEBPACK FOOTER //
// ./src/components/LangSelector.js